import React from "react";

const CartIcon = () => (
  <svg
    className="icon--cart"
    xmlns="http://www.w3.org/2000/svg"
    width="92.015"
    height="66.777"
    viewBox="0 0 92.015 66.777"
  >
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="4"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M62.887 59.494c0 2.916 2.367 5.283 5.286 5.283 2.92 0 5.286-2.367 5.286-5.283 0-2.922-2.366-5.288-5.287-5.288-2.92 0-5.286 2.366-5.286 5.288zM23.167 59.494c0 2.916 2.367 5.283 5.287 5.283s5.286-2.367 5.286-5.283c0-2.922-2.367-5.288-5.286-5.288-2.92 0-5.287 2.366-5.287 5.288zM24.053 46.342L10.11 2H0M26.606 54.543l-3.14-10.178M62.887 59.494H33.74M90.015 14.25H14l10.086 32.085H77.26zM16.017 20.673h70.576M18.04 27.1h66.866M20.023 33.525h61.074M22.08 39.95h57.688"
    />
  </svg>
);

export default CartIcon;
